import {
  discovery
} from '../constants';
import discoveryReducer from '../../helpers/discoveryReducer';

/**
 * Import constants
 */
const {
  SET_DISCOVERY_DATA,
  SET_WHOLE_DISCOVERY,
  UPDATE_DISCOVERY_DATA
} = discovery;

/**
 * Action creators
 */
const actions = {
  setDiscoveryData: (data) => ({ type: SET_DISCOVERY_DATA, data: discoveryReducer(data) }),
  updateDiscovery: (data) => ({ type: UPDATE_DISCOVERY_DATA, data }),
  setWhole: (data) => ({ type: SET_WHOLE_DISCOVERY, data })
};

/**
 * Set discovery data
 */
export const setDiscoveryData = (data) => (dispatch) => dispatch(actions.setDiscoveryData(data));

/**
 * Update discovery data
 */
export const updateDiscoveryData = (data) => (dispatch) => dispatch(actions.updateDiscovery(data));

/**
 * Update discovery data from mobile app
 */
export const setWhole = (data) => (dispatch) => dispatch(actions.setWhole(data));
